import { DigibonAPI } from '../api/digibon'
import { OrderStatesEnum } from '../constants/order'
import { StationTypesEnum } from '../constants/stations'

export const handleNextOrderState = (
    stationId: string,
    stationType: StationTypesEnum,
    orderKey: string,
    orderKitchenState: OrderStatesEnum,
    orderState: OrderStatesEnum,
    isAddressRequired: boolean
) => {
    if (orderKitchenState === OrderStatesEnum.NEW) {
        return DigibonAPI.startOrderProcess(stationId, orderKey, OrderStatesEnum.IN_PROCESS)
    }

    if (orderState === OrderStatesEnum.COOKED) {
        return DigibonAPI.updateOrderState(stationId, orderKey, OrderStatesEnum.ASSEMBLED)
    }

    if (orderState !== OrderStatesEnum.ASSEMBLED) return

    if (isAddressRequired) {
        return DigibonAPI.updateOrderState(stationId, orderKey, OrderStatesEnum.DELIVERING)
    }

    if (stationType === StationTypesEnum.PICKER_STATION) {
        return DigibonAPI.updateOrderState(stationId, orderKey, OrderStatesEnum.FINISHED)
    }
}
